import React from 'react'
import { useFormInputValidation } from "react-form-input-validation";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { verifyOtp as verifyOtpApi, resendOtp as resendOtpApi } from '../../api/apiHandler';

export default function OtpVerification() {
    const navigate = useNavigate()
    const location = useLocation();
    const { email, donor_id } = location.state || {};

    const [fields, errors, form] = useFormInputValidation({
        otp: "",
    }, {
        otp: "required|numeric",
    });

    const onSubmit = async (event) => {
        event.preventDefault();
        const isValid = await form.validate(event);
        if (isValid) {
            verifyOtp()
        }
    }

    const verifyOtp = () => {
        verifyOtpApi({ "otp": fields.otp, "donor_id": donor_id }).then((response) => {
            if (response.data.code == 1) {
                navigate('/sign-in')
            } else {
                alert(response.data.message || 'Invalid OTP');
            }
        });
    }

    const resendOtp = () => {
        resendOtpApi({ "email": email, "donor_id": donor_id, "otp_type": "Signup" }).then((response) => {
            if (response.data.code == 1) {
                // Maybe show a success message
            } else {

            }
        });
    }

    return (
        <div className="authentication">
            <div className="card">
                <div className="body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="header slideDown">
                                <div className="logo"><img src={process.env.PUBLIC_URL + "/assets/images/logo-2.png"} alt="Nexa" /></div>
                                <h1>Donor Panel</h1>
                            </div>
                        </div>
                        <form className="col-lg-12" id="form_validation" noValidate autoComplete="off" onSubmit={onSubmit} method="" action='#' >
                            <h5 className="title">Verify Your Account</h5>
                            <p>An OTP has been sent to {email}</p>
                            <div className="form-group form-float">
                                <div className="form-line">
                                    <input type="text" className="form-control" placeholder='OTP' id="otp" name="otp"
                                        onBlur={form.handleBlurEvent}
                                        onChange={form.handleChangeEvent}
                                        value={fields.otp} />
                                </div>
                                <label className="errorc" >{errors.otp ? errors.otp : ""}</label>
                            </div>
                            <div className="col-lg-12">
                                <button className="btn btn-raised btn-primary waves-effect" type="submit">VERIFY OTP</button>
                                &nbsp;
                                &nbsp;
                                <button className="btn btn-raised btn-info waves-effect" type="button" onClick={resendOtp}>RESEND OTP</button>
                            </div>
                            <br />
                            <div className='col-lg-12'>
                                <Link to="/sign-in" className="btn btn-raised btn-default waves-effect" type="submit">SIGN IN</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
